<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('Печать')}}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<b-card class="doc-body">
			<div class="text-center">
				<b style="font-size: 14px">SKY SHOP SERVICES №____________</b>
				<br>
				<span style="font-size: 12px; font-weight: bold">Приходно-пасходная накладная</span>
			</div>
			<b-row>
				<b-col cols="7" style="padding-top: 10px">
					<table style="width: 100%; border: 2px solid black" class="b-table table-bordered">
						<thead>
						<tr>
							<th style="font-size: 12px; padding: 2px">Номер рейса (вылет)</th>
							<th style="font-size: 12px; padding: 2px">Номер рейса (прилет)</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<th style="font-size: 12px; padding: 2px">Дата:</th>
							<th style="font-size: 12px; padding: 2px">Дата:</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px">из:</th>
							<th style="font-size: 12px; padding: 2px">из:</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px">номер самолета:</th>
							<th style="font-size: 12px; padding: 2px">номер самолета:</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px">количество пассажиров:</th>
							<th style="font-size: 12px; padding: 2px">количество пассажиров:</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px">ст.бортпроводник:</th>
							<th style="font-size: 12px; padding: 2px">ст.бортпроводник:</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px">рабочий номер:</th>
							<th style="font-size: 12px; padding: 2px">рабочий номер:</th>
						</tr>
						</tbody>
					</table>
				</b-col>
				<b-col cols="5">
					<div class="text-center" style="font-size: 12px; font-weight: bold">Номер пломбы</div>
					<table style="width: 100%; border: 2px solid black" class="b-table table-bordered">
						<thead>
						<tr>
							<th class="text-center" style="padding: 0"></th>
							<th class="text-center" style="padding: 0">Вылета</th>
							<th class="text-center" style="padding: 0">Хранен</th>
							<th class="text-center" style="padding: 0">При</th>
							<th class="text-center" style="padding: 0">Запас</th>
						</tr>
						<tr>
							<th class="text-center" style="padding: 0">кол.1</th>
							<th class="text-center" style="padding: 0">кол.2</th>
							<th class="text-center" style="padding: 0">кол.3</th>
							<th class="text-center" style="padding: 0">кол.4</th>
							<th class="text-center" style="padding: 0">кол.5</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="i in 5">
							<td class="text-center" style="padding: 10px">{{ ' ' }}</td>
							<td class="text-center" style="padding: 10px">{{ ' ' }}</td>
							<td class="text-center" style="padding: 10px">{{ ' ' }}</td>
							<td class="text-center" style="padding: 10px">{{ ' ' }}</td>
							<td class="text-center" style="padding: 10px">{{ ' ' }}</td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
			<b-row>
				<b-col style="border: 2px solid black" class="m-3 pb-2">
					<div style="font-size: 12px; font-weight: bold; text-decoration: underline" class="text-center">Вылет</div>
					<div style="font-size: 12px; font-weight: bold">Мы ................................ представляем товары описанные в колонках 2 и 3 ниже для перевозки со складов, для погрузки на указанные вылетающие самолеты</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">Дата............................................</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">подпись............................................</div>
				</b-col>
				<b-col style="border: 2px solid black" class="m-3 pb-2">
					<div style="font-size: 12px; font-weight: bold; text-decoration: underline" class="text-center">Складирование в других аэропортах</div>
					<div style="font-size: 12px; font-weight: bold">Мы ................................ представляем товары описанные в колонке 2 для импорта поступления на склады .................................. под пломбами, указанными в колонке 3(номера пломб)</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">Дата............................................</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">подпись............................................</div>
				</b-col>
				<b-col style="border: 2px solid black" class="m-3 pb-2">
					<div style="font-size: 12px; font-weight: bold; text-decoration: underline" class="text-center">Складирование возвращенного товара</div>
					<div style="font-size: 12px; font-weight: bold">Мы ................................ представляем товары описанные в колонке 2 для складирования на нашем складе под пломбой, указанной в колонке 4(номера пломб)</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">Дата............................................</div>
					<br>
					<div style="font-size: 12px; font-weight: bold">подпись............................................</div>
				</b-col>
			</b-row>
			<hr>
			<div class="text-center">
				<b style="font-size: 14px">РАСПИСКА</b>
				<br>
				<span style="font-size: 12px; font-weight: bold">о получении разменных денег и товара</span>
			</div>
			<div style="font-weight: bold"><span class="pl-3">Я</span> подтверждаю, что получил(а) разменные деньги ___________$ ___________$ ___________£ ___________₽ ___________Сум. Я также подтверждаю получение товаров, вписанных в колонках 2 и 3 на обратной стороне для продажи на борту указанного самолета. Так же мною получено:</div>
			<div><span class="pl-3">______________________________</span> Тележка______ , Вкладыши______ , Замки______ , Калькуляторы______ , Журналы______ .</div>
			<b-row class="mt-3">
				<b-col>
					<b>Выдал(Ф.И.О) ____________________________________ . </b><b class="ml-3"> _____________ Подпись</b>
				</b-col>
				<b-col>
					<b>Получил(Ф.И.О) ____________________________________ . </b><b class="ml-3"> _____________ Подпись</b>
				</b-col>
			</b-row>
			<hr>
			<div class="text-center">
				<b style="font-size: 14px">КВИТАНЦИЯ №____________</b>
				<br>
				<span style="font-size: 12px; font-weight: bold">на сдачу валютной/сумовой выручки "_____" ____________________г .</span>
			</div>
			<div style="font-weight: bold"><span class="pl-2">Продавец(Ф.И.О)</span>_________________________________________________________________________________ , таб № _________________________ , № рейса ________________________</div>
			<div style="font-weight: bold" class="mt-3">маршрут _____________________________________________ , дата _____________________________________ , накладной № ________________________</div>
			<hr>
			<b-row>
				<b-col v-for="(sale, index) in sales" :key="`sales-employee-${index}`">
					<table v-for="(brigade, inde) in sale.brigadeDtos" :key="`brigade-sale-${inde}`" style="width: 100%; border: 2px solid black" class="b-table table-bordered">
						<thead>
						<tr>
							<th colspan="3">
								<b-row>
									<b-col class="text-center"><b>№ продажи : </b> {{ sale.saleNumber }}</b-col>
									<b-col class="text-center"><b>Дата продажи : </b> {{ sale.saleDate }}</b-col>
									<b-col class="text-center"><b>Выручка $ : </b> {{ sale.amountOfPaymentUzs }}</b-col>
								</b-row>
							</th>
						</tr>
						<tr>
							<th colspan="3" style="font-size: 12px; padding: 2px" class="text-center">{{ brigade.name }}</th>
						</tr>
						<tr>
							<th style="font-size: 12px; padding: 2px" class="text-center">№</th>
							<th style="font-size: 12px; padding: 2px" class="text-center">Ф.И.О</th>
							<th style="font-size: 12px; padding: 2px" class="text-center">таб №</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(employee, ind) in brigade.employeeDtos" :key="`employee-sale-${ind}`">
							<td style="font-size: 12px; padding: 2px" class="text-center">{{ ind+1 }}</td>
							<td style="font-size: 12px; padding: 2px">{{ `${employee.lastName} ${employee.firstName} ${employee.middleName}` }}</td>
							<td style="font-size: 12px; padding: 2px" class="text-center">{{ employee.personnel }}</td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col>
					<div style="border: 2px solid black; width: 100%" class="text-center">Общая сумма продажи в $ : {{ sumPrice }}</div>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col>
					<table style="width: 100%; border: 2px solid black" class="b-table table-bordered">
						<thead>
						<tr>
							<th></th>
							<th>EUR</th>
							<th>USD</th>
							<th>GBP</th>
							<th>UZS</th>
							<th>RUB</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td><b>Курс</b></td>
							<td>1</td>
							<td><span v-for="(rate, index) in lastCurrencyRates" :key="`usd-${index}`"><span v-if="rate.currencyName==='USD'">{{ rate.rate }}</span></span></td>
							<td><span v-for="(rate, index) in lastCurrencyRates" :key="`gbp-${index}`"><span v-if="rate.currencyName==='GBP'">{{ rate.rate }}</span></span></td>
							<td><span v-for="(rate, index) in lastCurrencyRates" :key="`uzs-${index}`"><span v-if="rate.currencyName==='EUR'">{{ rate.rate }}</span></span></td>
							<td><span v-for="(rate, index) in lastCurrencyRates" :key="`rub-${index}`"><span v-if="rate.currencyName==='RUB'">{{ rate.rate }}</span></span></td>
						</tr>
						<tr>
							<td><b>Всего к сдаче</b></td>
							<td><span v-for="(pay, ind) in payments" :key="`pay-eur-${ind}`"><span v-if="pay.currencyName==='EUR'">{{ pay.currencyAmount }}</span></span></td>
							<td><span v-for="(pay, ind) in payments" :key="`pay-usd-${ind}`"><span v-if="pay.currencyName==='USD'">{{ pay.currencyAmount }}</span></span></td>
							<td><span v-for="(pay, ind) in payments" :key="`pay-gbp-${ind}`"><span v-if="pay.currencyName==='GBP'">{{ pay.currencyAmount }}</span></span></td>
							<td><span v-for="(pay, ind) in payments" :key="`pay-uzs-${ind}`"><span v-if="pay.currencyName==='UZS'">{{ pay.currencyAmount }}</span></span></td>
							<td><span v-for="(pay, ind) in payments" :key="`pay-rub-${ind}`"><span v-if="pay.currencyName==='RUB'">{{ pay.currencyAmount }}</span></span></td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
			<div class="mt-3" style="font-weight: bold">Сумма возвращенной разменной валюты _____________$ _____________$ _____________£ _____________₽ _____________Сум. Возврат каталогов _____________.</div>
			<div class="mt-3" style="font-weight: bold">Подпись лица, вносящего валютную/суммовую выручку _____________________________________________________________.</div>
			<div class="mt-3" style="font-weight: bold">Валютную/суммовую выручку принял клодовщик _____________________________________________________________________.</div>
		</b-card>
	</div>
</template>

<script>
import SkyShopService from "./skyshop.service";
import CurrencyService from "../../services/currency.service";

export default {
	name: "reportNakladnoy",
	data() {
		return {
			doc: {},
			sales: [],
			lastCurrencyRates: [],
			payments: [],
			loading: false
		}
	},
	computed: {
		totalCountItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=item.count
			})
			return sum
		},
		totalSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.skyQty?item.skyQty:0)
			})
			return sum
		},
		totalCountSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.count-(item.skyQty?item.skyQty:0))
			})
			return sum
		},
		totalPriceOfItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.count*item.priceUzs)
			})
			return sum
		},
		totalPriceOfSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=((item.skyQty?item.skyQty:0)*item.priceUzs)
			})
			return sum
		},
		sumPrice() {
			let sum = 0
			this.sales.forEach(s => {
				sum+=s.amountOfPaymentUzs
			})
			return sum
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		async getDoc() {
			this.loading = true
			await SkyShopService.getDocById(this.$route.params.id).then(res => {
				this.doc = res.data
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await SkyShopService.getReportSales(this.$route.params.id).then(res => {
				this.sales = res.data
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await CurrencyService.getCurrencyRatesForSky(this.doc.regDate).then(res => {
				this.lastCurrencyRates = res.data
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await SkyShopService.getSalePayments(this.doc.id).then(res => {
				this.payments = res.data
				this.loading = false
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
	},
	created() {
		this.getDoc();
	}
}
</script>

<style scoped>
@page  {
	margin: 1cm;
}
@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}
</style>
